import { Component, inject, Input } from '@angular/core';
import { BuildingEquipmentBadgeDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-building-equipment-badge',
  templateUrl: './building-equipment-badge.component.html',
  styleUrls: ['./building-equipment-badge.component.scss'],
})
export class BuildingEquipmentBadgeComponent {
  private readonly router = inject(Router);

  @Input()
  @Tracked()
  buildingEquipment?: BuildingEquipmentBadgeDto;

  navigate(event: MouseEvent): void {
    event.stopPropagation();
    this.router.navigate(['buildingEquipment', this.buildingEquipment!.id]);
  }
}
